@use './variables' as *;

:host {
  display: $checkbox-host-display;
}

.checkbox {
  display: $checkbox-display;
  align-items: $checkbox-align-items;
  position: relative;
  min-height: $checkbox-checkmark-height;
  padding-left: $checkbox-padding-left;
  margin-top: $checkbox-margin-top;
  margin-right: $checkbox-margin-right;
  margin-bottom: $checkbox-margin-bottom;
  margin-left: $checkbox-margin-left;
  box-sizing: $checkbox-box-sizing;
  &:not(.disabled) {
    cursor: $checkbox-cursor;
  }
  &::before,
  &::after {
    position: absolute;
    content: '';
    box-sizing: $checkbox-box-sizing;
  }
  &::before {
    width: $checkbox-checkmark-width;
    height: $checkbox-checkmark-height;
    top: $checkbox-checkmark-top;
    left: $checkbox-checkmark-left;
    border: $checkbox-checkmark-border;
    border-radius: $checkbox-checkmark-border-radius;
    background-color: $checkbox-checkmark-background-color;
  }
  &::after {
    display: none;
    width: $checkbox-checkmark-tick-width;
    height: $checkbox-checkmark-tick-height;
    top: $checkbox-checkmark-tick-top;
    left: $checkbox-checkmark-tick-left;
    border-left: $checkbox-checkmark-tick-border-left;
    border-bottom: $checkbox-checkmark-tick-border-bottom;
    transform: $checkbox-checkmark-tick-transform;
  }
  &[aria-checked]::after {
    display: block;
  }
  &:focus {
    outline: none;
    &:not(.disabled)::before {
      box-shadow: 0 0 0 $checkbox-checkmark-focus-width $checkbox-checkmark-focus-color;
    }
  }
  &:hover::before {
    background-color: $checkbox-checkmark-hover-background-color;
  }
  &.disabled::before {
    border: $checkbox-checkmark-disabled-border;
    background-color: $checkbox-checkmark-disabled-background-color;
  }
  .label {
    color: $checkbox-label-color;
    font-family: $checkbox-label-font-family;
    font-weight: $checkbox-label-font-weight;
    font-size: $checkbox-label-font-size;
    line-height: $checkbox-label-line-height;
  }
  .required-mark {
    color: $checkbox-mark-required-color;
  }
  &.status-error {
    &::before {
      border: $checkbox-checkmark-status-error-border;
    }
    .label {
      color: $checkbox-label-status-error-color;
    }
  }
}
